import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
//import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';
//help
import { VscArrowLeft } from "react-icons/vsc";
import { IoIosHelpCircle, IoIosHelpCircleOutline } from "react-icons/io";
import { VscVerifiedFilled } from "react-icons/vsc";
import { VscError } from "react-icons/vsc";
import { MdDone } from 'react-icons/md';
//page links  
import { FaStar } from "react-icons/fa";
import { IoMdAdd } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";
import './companys-profile.css';
export default function Companiesprofile({ data = {} }) {
  const location = useLocation();
  const navigate = useNavigate();
  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // Go back
    } else {
      navigate('/'); // No history, go to home
    }
  };
  const [loading, setLoading] = useState(true);
  const [Selected, setSelected] = useState('Overview');

  const [Pagetitle, setPagetitleData] = useState('Find the Right Job or Talent Faster');
  const [Pagedescription, setPagedescriptionData] = useState(
    'Find talent or your next opportunity on EditorTask. Post tasks, showcase creative work, and hire skilled editors and freelancers.'
  );

  useEffect(() => {
    if (data.title) {
      setPagetitleData(data.companyname);
    }
    if (data.description) {
      setPagedescriptionData(data.description);
    }
  }, [data]); // ✅ Added dependency array
  return (
    <div>

      <div className="status-bar">
        <div className="container_size">
          <div className="status-bar_size">
            <div className='left_body'>
              <VscArrowLeft onClick={handleGoBack} className='back_arrow_btn' />
            </div>
            <div className='name-bar-body'>Compnay Profile</div>
            <div className='right_body'>
              <div

                className={`help-button-icon ${location.pathname === '/help' ? 'active' : ''}`}
                title="Help Center"
              >
                {location.pathname === '/help' ? <IoIosHelpCircle className="icon" /> : <IoIosHelpCircleOutline className="icon" />}

                <span className="button-text">Help</span>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className='app_header_height'></div>
      <div className="container_roots">

        <Helmet>
          <title>{Pagetitle} | EditorTask - Find the Right Job or Talent Faster</title>

          <meta name="description" content={Pagedescription} />
          <meta
            name="keywords"
            content={`${Pagedescription}, job portal, freelance jobs, editor showcase, hire editors, post jobs, portfolio platform, task marketplace, India jobs, design gigs, video editing work`}
          />
          <meta name="author" content="editortask.com" />
          <meta name="robots" content="index, follow" />

          <meta
            property="og:title"
            content={`${Pagetitle} | EditorTask - Find the Right Job or Talent Faster`}
          />
          <meta property="og:description" content={Pagedescription} />
          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content={typeof window !== 'undefined' ? window.location.href : 'https://www.editortask.com/'}
          />
          <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
        </Helmet>

        <div className='companys-covers-body'>
          {loading && <div className="loading"><Lodinging /></div>}
          <img
            className="companys-covers-img"
            src={data.cover}
            alt="cover"
            onLoad={() => setLoading(false)}
            onError={() => setLoading(false)} // also hides loader if there's an error
            style={{ display: loading ? 'none' : 'block' }} // hide img while loading
          />
        </div>
        <div className='companys-body'>
          <div className="container_size">
            <div className='post-container'>
              <div className='profile-logo-div'>
                {loading && <div className="loading"><Lodinging /></div>}
                <img
                  className="companys-logo-img"
                  src={data.logo}
                  alt="Logo"
                  onLoad={() => setLoading(false)}
                  onError={() => setLoading(false)} // also hides loader if there's an error
                  style={{ display: loading ? 'none' : 'block' }} // hide img while loading
                />
              </div>
              <div className='post_div post-body'>
                <div>
                  <div className='companys-name-div'>
                    <table>
                      <tr>
                        <td><div className="name-text">{data.companyname}</div></td>
                        <td>  {
                          data.verification ? (
                            <div className='Virfied-div' title='Managed by employer'>
                              <VscVerifiedFilled className='virfied-img' />
                            </div>
                          ) : (
                            <div className='Virfied-div' title='Managed by employer'>
                              <MdDone className='unvirfied-img' />
                            </div>
                          )
                        }</td>
                      </tr>
                    </table>


                    <div className="rating-div"><FaStar className='items-rating' />{data.rating + "  |  " + data.reviws + " reviews"}</div>
                  </div>
                </div>
            
                <div className='industry-grid'>
                  {data.industry && (
                    <div className="industry-grid">
                      {data.industry.split(',').map((item, index) => (
                        <div key={index} className="industry-items">
                          {item.trim()}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
         
            </div>
          </div>
        </div>
            <br/>
        <div className="container_size">
          <div className='tabs-body'>
            <div
              onClick={() => setSelected('Overview')}
              className={`tabsbutton ${Selected === 'Overview' ? 'active' : ''}`}
              title="Overview"
            >
              <span className="tabs-text">Overview</span>
            </div>
            <div
              onClick={() => setSelected('Skills')}
              className={`tabsbutton ${Selected === 'Skills' ? 'active' : ''}`}
              title="Skills"
            >
              <span className="tabs-text">Skills</span>
            </div>
            <div
              onClick={() => setSelected('Why join')}
              className={`tabsbutton ${Selected === 'Why join Us' ? 'active' : ''}`}
              title="Why join Us"
            >
              <span className="tabs-text">Why join Us</span>
            </div>
            <div
              onClick={() => setSelected('Jobs')}
              className={`tabsbutton ${Selected === 'Jobs' ? 'active' : ''}`}
              title="Jobs"
            >
              <span className="tabs-text">Jobs</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
